'use strict';

/*global services*/

function K2ImageViewer(modal /*nepovinne*/) {
  this.modal = modal;

  this.init();
}

K2ImageViewer.prototype = $.extend({}, {
  constructor: 'K2ImageViewer',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.view-image', function () {
      var $this = $(this);

      var url = '';
      switch ($this.prop('tagName').toLowerCase()) {
        case 'img' : url = $this.attr('src'); break;
        default : url = $this.attr('href'); break;
      }

      _this.viewImage(url, $this.data('title'));
      return false;
    });
  },

  //----------------------------------------------------------------------------

  viewImage: function viewImage(url, title) {
    var _this = this;

    var html = '';
    html += '<div class="k2-image-viewer__wrapper">';
    html +=   '<img src="' + url + '" class="k2-image-viewer__image" />';
    html += '</div>';

    _this.modal.open({
      title: title,
      width: 'auto',
      height: 'auto',
      maxWidth: 800
    });
    _this.modal.content(html);
    _this.modal.block();
    _this.modal.contentDOM().find('.k2-image-viewer__image').bind('load', function () {
      _this.modal.unBlock();
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = _this.modal ? _this.modal : services.get('modal');
    _this.registerCallbacks();

    return _this;
  }
});
